import { c as _c } from "react/compiler-runtime";
import type { CicStatement } from "@/entities/IProfile";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import UserPageIdentityStatementsStatementsList from "../utils/UserPageIdentityStatementsStatementsList";
export default function UserPageIdentityStatementsNFTAccounts(t0) {
  const $ = _c(5);
  const {
    statements,
    profile,
    loading
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">NFT Accounts</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== loading || $[2] !== profile || $[3] !== statements) {
    t2 = <div>{t1}<UserPageIdentityStatementsStatementsList statements={statements} profile={profile} noItemsMessage="No NFT Account added yet" loading={loading} /></div>;
    $[1] = loading;
    $[2] = profile;
    $[3] = statements;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}